// InformationBox.js
import React from "react";
import MultiStyleButton from "../MultiStyleButton";

const InputFormAIInformationBox = ({
  isLoading,
  showSuccessScreen,
  currentSectionIndex,
  sections,
  isNew,
  systemName,
  uniqueId,
  formData,
  onCancel,
}) => {
  if (isLoading || showSuccessScreen) return null;

  return (
    <div className="information-box">
      <p className="information-box-title">
        {currentSectionIndex < sections.length
          ? isNew
            ? `You are creating a new record in ${systemName}. Navigation buttons are disabled during this process. Click Cancel to return to system.`
            : `You are editing a record in ${systemName}. Navigation buttons are disabled during this process, to navigate click Cancel Button.`
          : "DONE!"}
      </p>
      {currentSectionIndex < sections.length && (
        <>
          <p>Record ID: {uniqueId}</p>
          <p>Name: {formData.name || "(Not yet provided)"}</p>
          <MultiStyleButton
            buttonType="cancel"
            label="Cancel Add Record"
            onClick={onCancel}
          />
        </>
      )}
    </div>
  );
};

export default InputFormAIInformationBox;